/**
 * Design-board route (clawinstall-reseller-admin) — eagerly registers the file
 * route with its production gate and search validation; the frame registry and
 * all board components are deferred to the `.lazy.tsx` twin so the captured
 * CSS and 35 frame components never reach the always-loaded main chunk.
 *
 * The board renders the frozen design capture in
 * docs/design/clawinstall-reseller-admin for the pixel-convergence loop
 * (scripts/design-board-diff.ts) and for eyeballing frames during
 * /design-wire. It is not a product surface: production requests 404 via
 * `beforeLoad`, while dev (`development`) and preview (`preview`) keep it
 * reachable from the same build artifact.
 *
 * @since 1.0.0
 */
import { createFileRoute, notFound } from "@tanstack/react-router";

import { runtimeNodeEnv, shouldHideDesignBoard, validateDesignBoardSearch } from "~/lib/design-board.ts";

// Re-exported so the gate + search contract stays importable from the route module (its tests and the diff harness docs point here).
export { runtimeNodeEnv, shouldHideDesignBoard, validateDesignBoardSearch } from "~/lib/design-board.ts";
export type { DesignBoardSearch } from "~/lib/design-board.ts";

export const Route = createFileRoute("/design-board/clawinstall-reseller-admin")({
  beforeLoad: () => {
    if (shouldHideDesignBoard(runtimeNodeEnv())) {
      throw notFound();
    }
  },
  validateSearch: validateDesignBoardSearch,
});
